import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

import './HistoriskeBilder.scss'

class HistoriskeBilder extends Component {
    state = {
        projects: [],
        selectedProject: null,
        isVisible: false,
        isLoading: true
    }

    currentLayer = null

    UNSAFE_componentWillMount = () => 
    {
        this.props.expand.watch("expanded", (newValue, oldValue, property, object) => {
            if (!newValue) {
                this.setState({isVisible:false})
                return
            }

            if (this.state.projects.length == 0) {
                this.findProjectsByExtent()
            }
        })

        this.props.watchUtils.whenTrue(this.props.view, "stationary", () => {
            if (!this.state.isVisible) {
                this.setState({projects: [], isLoading: true})
                return
            }

            this.findProjectsByExtent()
        })
    }

    findProjectsByExtent = () => {
        this.setState({isLoading: true})
        let queryTask = new this.props.QueryTask({url:"https://services.geodataonline.no/arcgis/rest/services/Geomap_UTM33_EUREF89/GeomapBilder3/ImageServer?token="+this.props.token})
        let query = new this.props.Query()
        query.geometry = this.props.view.extent
        query.returnGeometry = false
        query.outFields = ["aar", "src_foto_date", "src_prosjektnavn"]
        query.where = "category=1 and src_foto_date is not null"

        let projects = []
        queryTask.execute(query).then(result => {
            result.features.map(feature => {
                if (projects.filter(project => (project.date == feature.attributes.src_foto_date)).length == 0) {
                    projects.push({name:feature.attributes.src_prosjektnavn, date:feature.attributes.src_foto_date, year:feature.attributes.aar })
                }
            })

            let newState = {
                projects: projects.sort(this.dateComparer),
                isLoading: false,
                isVisible: true
            }


            if (this.state.selectedProject != null && projects.filter(project => (project.date == this.state.selectedProject.date && project.name == this.state.selectedProject.name)).length == 0) {
                if (this.currentLayer) {
                    this.props.view.map.remove(this.currentLayer)
                    this.currentLayer = null

                    newState.selectedProject = null
                }
            }

            this.setState(newState)
        })
    }

    dateComparer = (a, b) => {
        if (a.date == null) return 1
        if (b.date == null) return -1

        if (a.date > b.date) return -1
        if (a.date < b.date) return 1
        return 0
    }

    selectProject = project => {
        if (this.currentLayer) {
            this.props.view.map.remove(this.currentLayer)
            this.currentLayer = null
        }

        if (this.state.selectedProject != null && this.state.selectedProject.date == project.date) {
            this.setState({selectedProject: null})
            return
        }

        var date = new Date(project.date)
        let layer = new this.props.ImageryLayer({
            url: "https://services.geodataonline.no/arcgis/rest/services/Geomap_UTM33_EUREF89/GeomapBilder3/ImageServer",
            timeExtent: {
                start: date,
                end: date
            },
            useViewTime: false
        })

        this.props.view.map.add(layer, 0)
        this.currentLayer = layer

        this.setState({selectedProject: project})
    }

    render() {
        if (this.state.isLoading) return (
            <div className="historiskebilder loading"><div className="spinner"><i className="fa fa-fw fa-spinner fa-spin"></i></div></div>
        )

        return (
            <div className="historiskebilder">
                <ul>
                {this.state.projects.map(project => {
                    return <li key={project.date} onClick={() => this.selectProject(project)}>
                            <div>
                                <span className={`icon esri-layer-list__item-toggle-icon ${this.state.selectedProject != null && this.state.selectedProject.date == project.date ? "esri-icon-visible" : "esri-icon-non-visible"}`}></span>
                                <span>{project.name}</span>
                            </div>
                        </li>
                })}
                </ul>
            </div>
        )
        
    }
}

export default withTranslation('common')(HistoriskeBilder)